import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ISpaceCoordinates } from '@api/types'

interface IPayload {
  data: {
    node: ISpaceCoordinates
  }
}

export default async function getSpaceCoordinates(ids: string): Promise<ISpaceCoordinates> {
  const variables = { ids }

  const {
    data: { nodes },
  } = await client.gql.query({ variables, query })
  return nodes[0]
}

const query = gql`
  query spaceCoordinates($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Space {
        x
        y
      }
    }
  }
`
